/* istanbul ignore file */
import React from 'react';
import { Box, Typography } from '@mui/material';
import type { Request } from './oneStopTypes';
import OneStopButtonsLayout from './OneStopButtonsLayout';
import { SanitizedHtml } from 'framework/utils';

type OneStopRequestLayoutProps = {
  request: Request;
  isFixedButtons?: boolean;
  children: React.ReactElement;
  headerRight?: React.ReactElement;
  handleCancelClick?: Nullable<() => void>;
};

const OneStopRequestLayout = ({
  children,
  request,
  headerRight,
  isFixedButtons = true,
  handleCancelClick,
}: OneStopRequestLayoutProps) => {
  const { id, title, description } = request;
  const isCustomRequestForm = !request.fields;

  const Title = () => {
    return (
      <Box display="flex" justifyContent="space-between" flexWrap="wrap" width="100%">
        <Typography variant="h4" color="brand" mr={1.25}>
          {`${id}. ${title}`}
        </Typography>
        {headerRight}
      </Box>
    );
  };

  const Description = () => {
    return (
      <Box sx={{ margin: '15px 0 17px', 'br + br': { content: '""', margin: '12px', display: 'block' } }}>
        {/* eslint-disable-next-line react/no-danger */}
        <SanitizedHtml html={description} />
      </Box>
    );
  };

  return (
    <>
      <Title />
      {description && <Description />}
      {children}
      {!isCustomRequestForm && <OneStopButtonsLayout onCancelAction={handleCancelClick} isFixed={isFixedButtons} />}
    </>
  );
};

export default OneStopRequestLayout;
